import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { AutodeskState } from './types';
const selectCache = (state: RootState) => state.autodeskCache;

export const selectAutodeskAuthInfo = createSelector(
  selectCache,
  (cache: AutodeskState) => cache.authInfo
);

export const selectAutodeskFile = createSelector(
  selectCache,
  (cache: AutodeskState) => cache.file
);

export const selectSameAutodeskFileLoaded = createSelector(
  selectCache,
  (cache: AutodeskState) => cache.sameFileLoaded
);

export const selectAutodeskLoadingTokenError = createSelector(
  selectCache,
  (cache: AutodeskState) => cache.loadingTokenError
);

export const selectAutodeskLoadingFileError = createSelector(
  selectCache,
  (cache: AutodeskState) => cache.loadingFileError
);
